import React from 'react'
import Index from '../../Index'
import PropTypes from 'prop-types';



export default function PrimaryButton({className, onClick, btnLabel }) {
  return (
    <>
      <Index.Box className='primary-btn-main'>
        <Index.Button className={className} onClick={onClick}>{btnLabel}</Index.Button>
      </Index.Box>


      {/* use this button like below demo */}
      {/* <Index.PrimaryButton btnLabel="View Button" className='primary-btn'/> */}
    </>
  )
}
PrimaryButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  btnLabel: PropTypes.string.isRequired
};